import apiClient from '@/lib/api';

export interface EngagementTotals {
  logins: number;
  activeUsers: number;
  stickinessPct: number;
  estimatedMinutes: number;
  transactions: number;
  failedLogins: number | null;
  dormantUsers: number;
  neverLoggedIn: number;
  newUsers: number;
}

export interface EngagementDaily {
  date: string;
  logins: number;
  activeUsers: number;
  transactions: number;
  estimatedMinutes: number;
  wau: number;
  mau: number;
  failedLogins: number | null;
}

export type EngagementUserStatus = 'active' | 'dormant' | 'never_logged_in';

export interface EngagementUser {
  userId: string;
  name: string;
  email: string;
  role: string;
  group: string | null;
  lastSeen: string | null;
  logins: number;
  sessions: number;
  estimatedMinutes: number;
  transactions: number;
  status: EngagementUserStatus;
}

export interface EngagementFeature {
  feature: string;
  action: string;
  area: string;
  transactions: number;
}

export interface EngagementData {
  /** Commander collection contract version. */
  contract: 1;
  /** ISO instant the response was built. */
  generatedAt: string;
  app: string;
  timezone: string;
  range: { from: string; to: string };
  previousRange: { from: string; to: string };
  definitions: {
    inactivityGapMinutes: number;
    sessionAllowanceMinutes: number;
    dormantAfterDays: number;
    includeExcluded: boolean;
    excludedRule: string;
  };
  recorded: { failedLogins: boolean; groups: boolean };
  excludedAccounts: number;
  totals: EngagementTotals;
  previous: EngagementTotals;
  daily: EngagementDaily[];
  heatmap: { weekday: number; hour: number; events: number }[];
  byUser: EngagementUser[];
  byFeature: EngagementFeature[];
  byGroup: { group: string; activeUsers: number }[] | null;
  security: {
    failedLoginsByUser: { userId: string; name: string; failedLogins: number; lastAt: string }[] | null;
  };
}

export async function getEngagementData(params: {
  from: string;
  to: string;
  includeExcluded: boolean;
}): Promise<EngagementData> {
  const { data } = await apiClient.get('/admin/engagement/data', {
    params: { from: params.from, to: params.to, includeExcluded: String(params.includeExcluded) },
  });
  return data;
}
